import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Calendar } from '@cocoonspace/ui/components/calendar'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { fr } from 'date-fns/locale/fr'

const locales = {
	fr,
}

export const DayPicker = ({
	className,
	value,
	onChange,
}: {
	value?: string
	onChange: (value: string) => void
	className?: string
}) => {
	const { i18n } = useLingui()

	return (
		<Calendar
			className={cn('mx-auto', className)}
			fromDate={dateTimeUtils().toDate()}
			locale={locales[i18n.locale as 'fr']}
			mode='single'
			onSelect={(value) => {
				if (value) {
					onChange(dateTimeUtils(value).format('YYYY-MM-DD'))
				}
			}}
			selected={value ? dateTimeUtils(value).toDate() : undefined}
			toDate={dateTimeUtils().add(1, 'year').toDate()}
		/>
	)
}
